import axios from 'axios'

export const http = axios.create({
    baseURL: 'https:///portal.pikolin.ind.br:4000/api/'
})

export const httpDatasul = axios.create({
    baseURL: 'https://portal.pikolin.ind.br:5000/api/'
})